import React from 'react';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import { Link, CssAnimation } from 'components/common';
import { BUTTON, LINK } from 'constants/components';
import DescriptionWithBackground from '../descriptionWithBackground';
import {
  DescriptionWrapper,
  TitleElement,
  ContinueLaterWrapper,
  ButtonElement
} from './StartNewAttempt.styled';

export const StartNewAttempt = props => {
  const startNewAttemptHandler = async () => {
    const { newAttempt, navigateToIndex } = props.popupSettings;
    const { closePopup } = props;
    await newAttempt();
    closePopup();
    navigateToIndex();
  };

  const renderDescription = () => (
    <CssAnimation type={CssAnimation.AnimationType.fadeInDown}>
      <DescriptionWrapper>
        <DescriptionWithBackground
          iconName="rounded-info"
          iconSize={12}
          descriptionText={localize('[start new attempt text]')}
        />
      </DescriptionWrapper>
    </CssAnimation>
  );

  return (
    <CssAnimation type={CssAnimation.AnimationType.fadeInDown}>
      <ContinueLaterWrapper>
        <TitleElement appearance="span" size={35}>
          {localize('[start new attempt title]')}
        </TitleElement>
        {renderDescription()}
        <ButtonElement layout={BUTTON.LAYOUT.PRIMARY} onClick={startNewAttemptHandler}>
          {localize('[start new attempt]')}
        </ButtonElement>
        <Link
          text={localize('[back to the course]')}
          layout={LINK.LAYOUT.FORM}
          onClick={props.closePopup}
        />
      </ContinueLaterWrapper>
    </CssAnimation>
  );
};

StartNewAttempt.propTypes = {
  closePopup: PropTypes.func.isRequired,
  popupSettings: PropTypes.object
};

export default StartNewAttempt;
